import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup.title',
    defaultMessage: 'Create your {brand} account',
  },
  intro: {
    id: 'signup.intro',
    defaultMessage: 'Start a free trial with your work account. No credit card needed.',
  },
  orWithEmail: {
    id: 'signup.orWithEmail',
    defaultMessage: 'Or sign up with your work email',
  },
  workEmail: {
    id: 'signup.workEmail',
    defaultMessage: 'Work email',
  },
  firstName: {
    id: 'signup.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'signup.lastName',
    defaultMessage: 'Last Name',
  },
  industry: {
    id: 'signup.industry',
    defaultMessage: 'Industry',
  },
  createAccount: {
    id: 'signup.createAccount',
    defaultMessage: 'Create account',
  },
  termsNote: {
    id: 'signup.termsNote',
    defaultMessage: 'By creating an account you agree to our',
  },
  haveAccount: {
    id: 'signup.haveAccount',
    defaultMessage: 'Already have an account?',
  },
  signIn: {
    id: 'signup.signIn',
    defaultMessage: 'Sign in',
  },
  backToSignIn: {
    id: 'signup.backToSignIn',
    defaultMessage: 'Back to sign in',
  },
  emailInvalid: {
    id: 'signup.emailInvalid',
    defaultMessage: 'Please enter a valid work email address.',
  },
  nameRequired: {
    id: 'signup.nameRequired',
    defaultMessage: 'Please enter your first and last name.',
  },
  tooMany: {
    id: 'signup.tooMany',
    defaultMessage: 'Too many attempts. Please wait a minute and try again.',
  },
  genericError: {
    id: 'signup.genericError',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  sentTitle: {
    id: 'signup.sent.title',
    defaultMessage: 'Check your inbox',
  },
  sentBody: {
    id: 'signup.sent.body',
    defaultMessage: 'If {email} qualifies for a trial, an activation link is on its way. Open it to finish setting up your account.',
  },
  sentHint: {
    id: 'signup.sent.hint',
    defaultMessage: 'Nothing after a few minutes? Check spam, or sign up with Google or Microsoft instead.',
  },
  adOptOut: {
    id: 'signup.adOptOut',
    // The website's wording (Privacy Policy, 4 Nov 2026); keep them identical.
    defaultMessage: 'Don’t let the ad that brought me here know I got in touch.',
  },
});
